import dayjs from "dayjs";

export function formatInvoiceAmount(total: string, currency: string): string {
  const amount = Number(total);

  if (Number.isNaN(amount)) return total;

  return new Intl.NumberFormat("en-US", {
    currency,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    style: "currency",
  }).format(amount);
}

export function formatInvoiceTotal(total: string, currency: string): string {
  return `${formatInvoiceAmount(total, currency)} ${currency}`;
}

export function formatInvoiceDate(date: string): string {
  return dayjs(date).format("MMM D, YYYY");
}

export function formatInvoiceLongDate(date: string): string {
  return dayjs(date).format("MMMM D, YYYY");
}

export function buildInvoiceLink(projectId: number, invoiceId: string): string {
  const search = new URLSearchParams({ invoice: invoiceId });

  return `${window.location.origin}/billing/${projectId}/invoices?${search.toString()}`;
}
